import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import Fade from 'react-reveal/Fade';
import { media } from '../../src/styles/media';
import { Section } from '../../src/components/Layout';
import { Container, Row, Column } from '../../src/components/Grid';
import { H3 } from '../../src/components/Title';
import IButton from '../../src/components/Button/IButton';
import Icon from '../../src/components/Icon';
import sortByOrder from '../../src/utils/collection/sortByOrder';
import Button from '../../src/components/Button';

const Label = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  font-size: 1rem;
  letter-spacing: 0.2px;

  color: ${props => props.theme.color.primary};

  margin-top: ${props => props.theme.layout.gutter / 4}px;

  > span {
    display: none;

    margin-right: ${props => props.theme.layout.gutter / 2}px;
  }

  ${media.tablet`
    justify-content: space-between;

    font-size: 1.3rem;
    line-height: 1;

    > span { display: block; }
    i { font-size: 1rem; }
  `};
`;

const ButtonWrapper = styled.div`
  margin-top: 10px;
`;

class Services extends React.PureComponent {
  render() {
    const { data, t } = this.props;

    return (
      <Section>
        <Container>
          <Fade up>
            <H3 icon="services" border={true}>
              {t('common:infos.services.title')}
            </H3>
          </Fade>
          <Fade up>
            <Row space={10}>
              {data.map((service, index) => (
                <Column
                  key={index}
                  mobile={1}
                  tablet={2}
                  desktop={4}
                  space={10}
                >
                  <IButton href={service.detail.cta_url} img={service.picto}>
                    {service.detail.name}
                    <ButtonWrapper>
                      <Button iconType="arrowBottomRight">
                        {service.detail.cta_label}
                      </Button>
                    </ButtonWrapper>
                  </IButton>
                </Column>
              ))}
            </Row>
          </Fade>
        </Container>
      </Section>
    );
  }
}

Services.propTypes = {
  data: PropTypes.array.isRequired
};

export default translate()(Services);
